'use client'

import Link from 'next/link'
import { useLocale } from 'next-intl'
import type { Template } from '@/lib/types'
import { OptimizedTemplateImage } from '@/components/home-v3/projects/template/optimized-template-image'

export function TemplateCard({ template }: { template: Template }) {
  const locale = useLocale()
  return (
    <Link
      href={`/template/${template.slug || template._id}`}
      className="w-full text-left group"
    >
      <div className="rounded-xl transition-all duration-200 bg-black/[0.05] backdrop-blur-md border border-white/20 hover:border-white/40 hover:scale-[1.02] overflow-hidden">
        <div className="relative">
          <div className="w-full aspect-video rounded-t-lg overflow-hidden">
            <OptimizedTemplateImage
              src={template.image_url}
              alt={template.title}
              className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
            />
          </div>
        </div>
        <h3 className="text-[16px] mb-1 text-white px-6 py-4 truncate">
          {template.title_i18n?.[locale] || template.title}
        </h3>
      </div>
    </Link>
  )
}
